import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Router} from "@angular/router";
import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";

import { isEqual } from 'lodash';

import {Vehicle} from "@commons/models/domain/Vehicle";
import {MapConfigService} from "@commons/services/map/config/map-config.service";
import { MapService } from '@commons/services/map/map/map.service';
import { IFilterVehicle, IOnChangedTachoFilters } from '@src/app/interfaces/filters-vehicle.interface';
import { VehicleListTypeDataVisible } from '@layout/vehicle/components/configurator-list-vehicle/configurator-list-vehicle.component';
import { VehicleListFilterRequest } from '@commons/models/remote.request/VehicleListFilterRequest';
import { VehicleListFilterComponent } from '@layout/vehicle/filter/vehicle-list-filter.component';
import { PermissionService } from '@shared/services/permission.service';

@Component({
  selector: 'vehiclem-vehicle-list',
  templateUrl: './vehicle-list.component.html',
  styleUrls: ['vehicle-list.component.less']
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class VehicleListComponent implements OnInit {

  @Output() private onChangeFilters$: EventEmitter<VehicleListFilterRequest> = new EventEmitter();
  @Output() private onChangeTachoFilters$: EventEmitter<IOnChangedTachoFilters> = new EventEmitter();

  @Input() vehicles?: Vehicle[];
  @Input('currentFilter') set currentFilter(data: VehicleListFilterRequest) {
    if (!isEqual(this._currentFilter, data)) {
      this._currentFilter = {...(data || {})};
      setTimeout(() => {
        this.filtersComponent.setFilters(this._currentFilter);
      }, 0);
    }
  };

  @Input('selectedVehicleId') set selectedVehicleId(data: any) {
    if (this._selectedVehicleId !== data) {
      this._selectedVehicleId = data;
      this.scrollToSelectedItem();
    }
  }
  @Input() group: number = 0;
  @Input() isEtoll: boolean;
  @Input() isTachoView: boolean;
  @Input() tachoFilters: IOnChangedTachoFilters;

  @Input() listDataTypeVisible: VehicleListTypeDataVisible;

  @ViewChild(CdkVirtualScrollViewport) list?: CdkVirtualScrollViewport;
  @ViewChild('filtersComponent') private filtersComponent: VehicleListFilterComponent;

  filterHeight = 150;
  public _selectedVehicleId: number;
  public _currentFilter: any;
  public hasBlockerReadPermissionUser: boolean;

  public readonly filters: IFilterVehicle[] = [];

  constructor(
    private router: Router,
    private mapService: MapService,
    private mapConfigService: MapConfigService,
    private permissionService: PermissionService
  ) {}

  ngOnInit(): void {
    this.checkIfUserCanVisibleBlockerInfo();
  }

  public onFilterTachoChanged(filters: IOnChangedTachoFilters): void {
    this.onChangeTachoFilters$.emit(filters);
  }

  private checkIfUserCanVisibleBlockerInfo(): void {
    this.hasBlockerReadPermissionUser = this.permissionService.hasBlockerRead() || this.permissionService.hasBlockerReadWrite();
  }

  private scrollToSelectedItem(id: number = this._selectedVehicleId): void {
    if (id) {
      const vehicleToScroll = this.vehicles?.findIndex(x => x.Id === id);
      if (vehicleToScroll)
        this.list?.scrollToIndex(vehicleToScroll);
    }
  }

  onSelect(vehicle: Vehicle): void {
    // odznaczenie i zaznaczenia
    if (vehicle.Id && this._selectedVehicleId === vehicle.Id) {
      this._selectedVehicleId = undefined as any;
      this.mapConfigService.setCurrentVehicleId('tk-vehicle-details', undefined);
      this.router.navigate(['panel', 'vehicle'], {queryParams: {'mode': 'lite'}});
      this.mapService.centerMap();
    } else {
      this._selectedVehicleId = vehicle.Id;
      this.mapConfigService.setCurrentVehicleId('tk-vehicle-details', this._selectedVehicleId);
      this.router.navigate(['panel', 'vehicle'], {queryParams: {'mode': 'details', 'id': this._selectedVehicleId}});
    }
  }

  onDisplayFieldChanged(group: number) {
    this.group = group;
  }

  handleOnHeightChanged(evt: number) {
    // filr ma 133px a lista musi się zaczynać na 150px
    // stad przesunięcie
    this.filterHeight = evt + 17;
  }

  onFilterChanged(filter: VehicleListFilterRequest) {
    if (filter) {
      const isStatusNull = !filter.Status || filter.Status === 0;
      const isTagsNull = !filter.Tags || filter.Tags.length === 0;
      const isPhraseNull = !filter.Phrase;
      const isLockNull = filter.IgnitionBlockerState === null;

      if (isStatusNull && isTagsNull && isPhraseNull && isLockNull) {
        this._currentFilter = null;
        this.onChangeFilters$.emit(null as any);
        return;
      }
    }

    this._currentFilter = filter;
    this.onChangeFilters$.emit(filter);
  }
}
